import nikeClient from '../services/nikeClient';

const QUERY = '(storeStatus==OPEN%20or%20storeStatus==UNOPENED%20or%20storeStatus==CLOSED)';
const FIELDS = 'address.country';
const LIMIT = 3000;

const buildPath = (anchor) =>
  `/store/store_views/v2?search=${QUERY}&fields=${FIELDS}&count=${LIMIT}` +
  (anchor ? `&anchor=${anchor}` : '');

const fetchAllCountries = async () => {
  try {
    const paths = [buildPath(), buildPath(LIMIT)];
    const responses = await Promise.all(paths.map(p => nikeClient.get(p)));

    const objects = responses.flatMap(r => r.data.objects || []);
    const countries = [...new Set(objects.map(o => o?.address?.country).filter(Boolean))].sort();
    return countries.map(c => ({ value: c, label: c }));
  } catch (e) {
    console.error('fetchAllCountries failed:', e.response?.status, e.config?.url);
    return [];
  }
};

export default fetchAllCountries;